<div class="dark-view" [ngClass]="{progress}">
  <div class="loading-container" *ngIf="!progress">
    <svg class="spinner" viewBox="0 0 50 50">
      <circle
        class="path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-width="5"
      ></circle>
    </svg>
    <div class="success" [class.show]="isDone">
      <img src="assets/general/tick-gray.svg" alt="" />
    </div>
    <p>صبر کنید …</p>
  </div>
  <div class="loading-container-progress" *ngIf="progress">
    <svg class="spinner" viewBox="0 0 50 50">
      <circle
        class="path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-width="5"
      ></circle>
    </svg>
    <div class="success percent" [class.show]="progress == 100">
      <img src="assets/general/tick-gray.svg" alt="" />
    </div>
    <p>{{ progress }}%</p>
    <p *ngIf="progress < 100">درحال آپلود</p>
    <p *ngIf="progress == 100">آپلود با موفقیت انجام شد</p>
  </div>
</div>
